import React from 'react';

import { NewInvoiceIcon } from '../../../Assets/Navigation/NavigationIcons';
import Email from '../../../Components/Email/Email';
import { t } from 'i18next';

const InvoiceEmail = (props) => {
  return (
    <Email
      {...props}
      Icon={NewInvoiceIcon}
      name={t('Settings.invoices')}
      onCancelURL="/invoices"
      emailAPI={`invoices/${props.match.params.id}/mail`}
      fetchDataAPI={`invoices/${props.match.params.id}/mail`}
      getBackTab
    />
  );
};

export default InvoiceEmail;
